import React, { useState } from "react"

import { gql, useQuery } from "urql"

import Table from "~Tutor/components/StudyGroupsTable"
import { H2, WithLoadingIndicator } from "~tailwindui/Basics"
import AutocompleteNavigate from "~tailwindui/Form/AutocompleteNavigate"

const StudyGroupsIndex = () => {
  const [futurePage, setFuturePage] = useState(1)
  const [assignedPage, setAssignedPage] = useState(1)

  const [result] = useQuery({
    query,
    variables: { futurePage, assignedPage },
  })

  return (
    <WithLoadingIndicator result={result}>
      {({ data: { viewer } }) => (
        <>
          <H2>My Study Groups</H2>
          <AutocompleteNavigate
            resource="studyGroups"
            placeholder="Quick Find a Study Group"
            navigateTo="studyGroupDetails"
            className="w-64"
          />

          {viewer.futureStudyGroups.data.length > 0 && (
            <>
              <Table
                studyGroups={viewer.futureStudyGroups}
                title="Future Study Groups"
                changePage={setFuturePage}
              />
            </>
          )}

          <Table
            studyGroups={viewer.assignedStudyGroups}
            title="Assigned Study Groups"
            changePage={setAssignedPage}
          />
        </>
      )}
    </WithLoadingIndicator>
  )
}

const query = gql`
  query StudyGroupsIndex($futurePage: Int, $assignedPage: Int) {
    viewer {
      id
      subjects {
        id
        name
      }
      futureStudyGroups: studyGroups(future: true, page: $futurePage) {
        currentPage
        totalPages
        data {
          id
          name
          subjects {
            id
            name
          }
          students {
            id
            fullName
          }
          allAvailabilities {
            id
            startsAt
            endsAt
            weekday
          }
        }
      }
      assignedStudyGroups: studyGroups(
        orderByLastSession: true
        page: $assignedPage
      ) {
        currentPage
        totalPages
        data {
          id
          name
          subjects {
            id
            name
          }
          students {
            id
            fullName
          }
          allAvailabilities {
            id
            startsAt
            endsAt
            weekday
          }
        }
      }
    }
  }
`

export default StudyGroupsIndex
